<template>
    <div class="mt-8 mb-4 p-3 rounded-14 border border-a-brown-d7c7b8">
        <div class="text-16 text-a-brown-502314 font-bold">{{lbl.earnpoint.benefits}}</div>
        <div class="flex items-center mt-5" v-for="(v,k) in benefits" :key="k">
            <img class="w-7" :src="v.image_url">
            <div class="ml-4 text-14 text-a-brown-502314">
                {{ localeCode == 1033 ? v.benefit_en :v.benefit}}
            </div>
        </div>
    </div>
</template>
<script>
import ProfilePointMixin from '@/mixin/ProfilePointMixin'
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    mixins: [ProfilePointMixin, LocaleMixin],
    data: function () {
        return {
            benefits: [],
        };
    },
    created: function () {
        this.setBenefit();
    },
    methods: {
        setBenefit: function () {
            // ProfilePointMixin
            this.getProfileLevel().then((profileLevel) => {
                //console.log('benefit', profileLevel);
                let levelDetail = this.getLevelDetail(profileLevel);
                //console.log('level detail', levelDetail);

                this.benefits = levelDetail.benefits;
            }).catch((err) => {
                console.log(err);
            });
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
